import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const getMessage = (params: URLSearchParams) => {
  if (params.get('success')) return { text: 'Vous êtes bien inscrit à cet événement !', color: 'green' };
  if (params.get('already')) return { text: 'Vous êtes déjà inscrit à cet événement.', color: 'blue' };
  if (params.get('full')) return { text: "L'événement est complet.", color: 'red' };
  return { text: 'Action inconnue.', color: 'gray' };
};

export default function EventRegistered() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { text, color } = getMessage(params);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const getColorClasses = (color: string) => {
    switch (color) {
      case 'green': return 'bg-green-100 text-green-800 border-green-200';
      case 'blue': return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'red': return 'bg-red-100 text-red-800 border-red-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md mx-auto text-center p-8">
        <div className={`status-panel p-8 rounded-3xl border ${getColorClasses(color)}`}>
          <h1 className="text-2xl font-bold mb-4">Confirmation</h1>
          <p className="text-lg mb-6">{text}</p>
          <p className="text-sm mb-6">Redirection vers l'accueil dans 10 secondes...</p>
          <button
            onClick={() => navigate('/')}
            className="btn-primary"
          >
            Retour à l'accueil maintenant
          </button>
        </div>
      </div>
    </div>
  );
}
